module.exports = __webpack_public_path__ + "img/hongkong_001.279570fd.jpg";